import React, { useEffect } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import OrderDetails from './pages/order-details/order-details';
import BillDetails from './pages/bill-details/bill-details';
import PaymentDetails from './pages/payment-details/payment-details';
import InvoicePage from './pages/invoice-details/invoice-page';
import CCAvenueTxnInitPage from './pages/ccavenue-txn/init';
import VisitCentreConfirmation from './pages/visit-centre-confirmation/visit-centre-confirmation';
import BillingAddressPage from './pages/billing-address/billing-address-page';
import NotFound from './pages/not-found/not-found';
import Layout from './layouts/layout';
import { initializeAnalytics } from './utils/analytics';

const router = createBrowserRouter([{
  // eslint-disable-next-line react/jsx-filename-extension
  element: <Layout />,
  path: ':orgId',
  children: [
    // `handle.gate` is the whole of the gating policy: a route that declares one
    // is gated on the buyer owning that resource, a route that does not is open.
    // Keeping it here means "which pages are gated" is answerable by reading
    // these nine lines.
    {
      path: 'orders/:orderId',
      element: <OrderDetails />,
      handle: { gate: { resourceType: 'order', param: 'orderId' } },
    },
    {
      path: 'bills/:billId',
      element: <BillDetails />,
      handle: { gate: { resourceType: 'bill', param: 'billId' } },
    },
    {
      path: 'invoices/:invoiceId',
      element: <InvoicePage />,
      handle: { gate: { resourceType: 'invoice', param: 'invoiceId' } },
    },
    // Ungated, each for its own reason:
    //   visit-centre-confirmation — a static thank-you page with no personal
    //     data; gating it would ask for a code on a confirmation screen.
    //   payment/:transactionId — where the gateway returns the student AFTER
    //     they have paid. Trapping somebody who has just been charged behind a
    //     login form is the worst thing this feature could do, so this one is
    //     never gated, in any mode.
    //   ccavenue-txn/init — a machine hop that immediately posts a hidden form
    //     to the gateway, and whose one-time key is consumed on read. An
    //     interstitial here burns the key and the payment dies.
    //   student-address — the address link a centre sends; the link's own token
    //     is the credential, and it opens nothing but this student's address.
    //     billing-address is its old path, kept so links already sent (they
    //     live 30 minutes) still open after the rename.
    { path: 'orders/:orderId/visit-centre-confirmation', element: <VisitCentreConfirmation /> },
    { path: 'payment/:transactionId', element: <PaymentDetails /> },
    { path: 'ccavenue-txn/init/:txnId', element: <CCAvenueTxnInitPage /> },
    { path: 'student-address', element: <BillingAddressPage /> },
    { path: 'billing-address', element: <BillingAddressPage /> },
  ],
}, { path: '*', element: <NotFound /> }]);

function App() {
  useEffect(() => {
    initializeAnalytics();
  }, []);

  return <RouterProvider router={router} />;
}

export default App;
